import { LOCATION_CHANGE } from 'react-router-redux';

import { Map as ImmMap } from 'immutable';

export const initialState = ImmMap({
	currentPage: '',
});

const breadcrumbsReducer = (state = initialState, action) => {
	switch (action.type) {
		case LOCATION_CHANGE: {
			return state.set('currentPage', action.payload.pathname);
		}
		default:
			return state;
	}
};

export default breadcrumbsReducer;
